import api from "api/api";

export type SupplierBusyPeriodDto = {
  id: number;
  supplierForEntityId: number;
  startDate: string;
  endDate: string;
  canAcceptSmallAssignments: boolean;
  comments?: string | null;
};

export type UpsertBusyPeriodPayload = {
  startDate: string;
  endDate: string;
  canAcceptSmallAssignments: boolean;
  comments?: string;
};

export const fetchBusyPeriods = async (): Promise<SupplierBusyPeriodDto[]> => {
  const response = await api.get<SupplierBusyPeriodDto[]>("/api/BusyPeriods");
  return response.data;
};

export type BusyPeriodOverlapParams = {
  startDate: string;
  endDate: string;
  ignoreBusyPeriodId?: string;
};

export const fetchBusyPeriodOverlap = async (params: BusyPeriodOverlapParams): Promise<string[]> => {
  const response = await api.get<string[]>("/api/BusyPeriods/overlap", {
    params: {
      startDate: params.startDate,
      endDate: params.endDate,
      ignoreBusyPeriodId: params.ignoreBusyPeriodId,
    },
  });
  return response.data;
};

export const createBusyPeriod = async (payload: UpsertBusyPeriodPayload): Promise<SupplierBusyPeriodDto> => {
  const response = await api.post<SupplierBusyPeriodDto>("/api/BusyPeriods", payload);
  return response.data;
};

export const updateBusyPeriod = async (
  id: string,
  payload: UpsertBusyPeriodPayload
): Promise<SupplierBusyPeriodDto> => {
  const response = await api.put<SupplierBusyPeriodDto>(`/api/BusyPeriods/${id}`, payload);
  return response.data;
};

export const deleteBusyPeriod = async (id: string): Promise<void> => {
  await api.delete(`/api/BusyPeriods/${id}`);
};
